import React from 'react';

// value is the value
const Select = ({
  name,
  value,
  options,
  label = '',
  className = '',
  id,
  disabled,
  handleChange,
  placeholderMessage,
  validationMessage,
  validationError,
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      <select
        className={`${
          validationError ? 'error' : ''
        } ${className} c-form__input`}
        id={name}
        name={name}
        disabled={disabled}
        defaultValue={value || placeholderMessage}
        onChange={onChange}
      >
        {placeholderMessage && (
          <option disabled value={placeholderMessage}>
            {placeholderMessage}
          </option>
        )}

        {options.map(({ display, value }, index) => (
          <option value={value} key={`option--${index}`}>
            {display}
          </option>
        ))}
      </select>

      {validationError && (
        <p className="c-form__error u-weight--semibold u-mb-0">
          {validationMessage}
        </p>
      )}
    </>
  );
};

export default Select;
